<template>
  <md-datepicker
    @input="emitInput"
    :md-close-on-blur="false"
    :value="value"
    :md-model-type="String"
    :md-open-on-focus="!disabled"
    :md-clearable="clearable"
    :md-disabled-dates="disabledDates"
  />
</template>

<script>
export default {
  props: {
    disabled: { type: Boolean, default: false },
    value: { type: String, default: '' },
    clearable: { type: Boolean, default: true },
    /** @type {Array|Function|null} vue-material md-disabled-dates */
    disabledDates: { type: [Array, Function], default: null },
  },
  methods: {
    emitInput(value) {
      this.$emit("input", value);
    }
  },
};
</script>
